/** The signed-in attorney's own defaults, which each new draft of theirs starts with. */

import { get, put } from "@/services/api-client";
import type {
  ClaimMarkerScheme,
  ClaimPreferences,
} from "@patent-studio/api-types";

/** The lettering a new draft of the attorney's starts its claims in. */
export function readClaimPreferences(): Promise<ClaimPreferences> {
  return get<ClaimPreferences>("/preferences/claims");
}

/** Make this the lettering each new draft starts in; no draft already made moves. */
export function chooseClaimPreferences(
  scheme: ClaimMarkerScheme,
): Promise<ClaimPreferences> {
  return put<ClaimPreferences>("/preferences/claims", {
    marker_scheme: scheme,
  });
}
